module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-body"
  }, [(this.$route.query.status === 'success') ? _c('div', [_c('div', {
    staticClass: "jumbotron text-center"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Thank You!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Status: " + _vm._s(this.$route.query.message) + "\n            "), _c('br'), _vm._v("\n            Transaction Id : " + _vm._s(this.$route.query.transaction_id) + "\n            "), _c('br'), _vm._v("\n            Order Id : " + _vm._s(this.$route.query.order_id))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "to": "/emiCollection"
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat",
    on: {
      "click": function($event) {
        return _vm.printPaytmView(_vm.paytmRecords)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View Receipt")])], 1)])]) : _vm._e(), _vm._v(" "), (this.$route.query.status !== 'success') ? _c('div', {
    staticClass: "callout callout-danger"
  }, [_c('div', {
    staticClass: "jumbotron text-center"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Transaction Failed!")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Status: " + _vm._s(this.$route.query.message) + "\n            "), _c('br'), _vm._v("\n            Transaction Id : " + _vm._s(this.$route.query.transaction_id) + "\n            "), _c('br'), _vm._v("\n            Order Id : " + _vm._s(this.$route.query.order_id))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "to": "/emiCollection"
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat",
    on: {
      "click": function($event) {
        return _vm.printPaytmView(_vm.paytmRecords)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View Receipt")])], 1)])]) : _vm._e()])]), _vm._v(" "), _c('paytmreceiptview', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead text-success"
  }, [_c('strong', [_vm._v("This is a confirmation message that we’ve received your payment.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Having trouble? "), _c('a', [_vm._v("Contact us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead text-danger"
  }, [_c('strong', [_vm._v("Oh no, Your Payment Failed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Having trouble? "), _c('a', [_vm._v("Contact us")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31f80828!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comman/Thankyou.vue
// module id = 807
// module chunks = 0